/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Expense_Clear_Duplicate_SuccessInputs */

const vi_toast_expense_clear_duplicate_success = /** @type {(inputs: Toast_Expense_Clear_Duplicate_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đánh dấu không trùng`)
};

/**

* @param {Toast_Expense_Clear_Duplicate_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_expense_clear_duplicate_success = /** @type {((inputs?: Toast_Expense_Clear_Duplicate_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Expense_Clear_Duplicate_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_expense_clear_duplicate_success(inputs)
});